<template>
  <li>
    <label :for="`select-${word.text}`" v-if="isSelecting" :class="{'editable': isSelecting}">
      <input type="checkbox" :id="`select-${word.text}`"
             :name="`select-${word.text}`" :checked="word.selected"/>
    </label>
    <div class="word-list__word-container">
      <div class="word-list__word-heading">
        <p class="word-list__word-text"
           :class="{'text-capitalize': word.type=='noun'}">
          {{
            word.type === 'noun' ?
              nounArticle(word.textLanguage, word.gender) : ''
          }} {{ word.text }}
        </p>
        <div class="word-list__word-flags">
          <FontAwesomeIcon
            v-if="CanSpeak"
            :icon="faVolumeHigh" class="word-list__word-speaker"
            @click.stop="speak(word.text, word.textLanguage)"
          />
          <img :src="imageURL(flags[word.textLanguage])"
               alt="" class="word-list__word-flags-text">
          <img :src="imageURL(flags[word.meaningLanguage])"
               alt="" class="word-list__word-flags-meaning">
        </div>
      </div>
      <div class="word-list__word-block">
        <p class="word-list__word-block-meaning"
           :class="{'text-capitalize': word.type=='noun'}"
        >
          {{ word.meaning }}
        </p>

        <FontAwesomeIcon v-if="word.type" class="word-list__word-block-dot"
                         :icon="faCircleDot"/>
        <p v-if="word.type" class="word-list__word-block-type">{{ t(word.type) }}</p>

        <FontAwesomeIcon v-if="word.gender" class="word-list__word-block-dot"
                         :icon="genderIcon(word.gender)"/>
        <p v-if="word.gender" class="word-list__word-block-gender">
          {{ t(gendersData[word.gender]) }}
        </p>
      </div>
    </div>

  </li>
</template>

<script lang="ts">
import { mixins, Options } from 'vue-class-component';
import { PropType } from 'vue';
import { GenericObject, Selectable } from '@/includes/definitions/index.d';
import ImageMixin from '@/includes/mixin/images.mixin';
import { flags } from '@/includes/db/data/languages';
import LanguageMixin from '@/includes/mixin/language.mixin';
import AudioMixin from '@/includes/mixin/audio.mixin';
import {
  faCircleDot,
  faNeuter,
  faPerson,
  faPersonDress,
  faPlusCircle,
  faUsers,
  faVolumeHigh,
} from '@fortawesome/free-solid-svg-icons';
import gendersData from '@/includes/db/data/genders.data';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { nounArticle } from '@/includes/definitions/word';

@Options({
  methods: { nounArticle },
  components: { FontAwesomeIcon },
  props: {
    word: {
      type: Object as PropType<Selectable<Text>>,
      required: true,
    },
    isSelecting: {
      type: Boolean,
      required: true,
    },
  },
})
export default class WordListItem extends mixins(ImageMixin, LanguageMixin, AudioMixin) {
  faPlusCircle = faPlusCircle;
  faPersonDress = faPersonDress;
  faCircleDot = faCircleDot;
  faNeuter = faNeuter;
  faPerson = faPerson;
  faUsers = faUsers;
  faVolumeHigh = faVolumeHigh;
  flags: GenericObject = flags;
  gendersData = gendersData;
  nounArticle = nounArticle
  word: Selectable<Text>;
  isSelecting: boolean;

  genderIcon(gender: string) {
    const map = {
      n: this.faNeuter,
      f: this.faPersonDress,
      m: this.faPerson,
      pl: this.faUsers,
    } as GenericObject;
    return map[gender];
  }
}
</script>

<style scoped lang="scss">
@import "../../assets/styles/variables.scss";

li {
  display: flex;
  justify-content: end;
  border-bottom: 1px solid rgba($dark, 0.3);
  text-align: left;
  padding: 13px 20px;
  cursor: pointer;

  p {
    margin: 0;
  }

  .word-list__word-speaker {
    margin-left: 8px;
    font-size: .9rem;
    color: rgba($dark, 0.6);
    cursor: pointer;
  }
}
</style>
